import { apiGetOne } from './ApiBaseActions';
export const API_GET_ONE_PROFESSIONAL = 'API_GET_ONE_PROFESSIONAL';
export const API_GET_ONE_PROFESSIONAL_SUCCESS = 'API_GET_ONE_PROFESSIONAL_SUCCESS';
export const apiGetOneProfessional = (id, meta) => apiGetOne(API_GET_ONE_PROFESSIONAL, `/professional/${id}`, Object.assign({ id }, (meta || {})));
export const apiGetOneFreeProfessional = (id, meta) => apiGetOne(API_GET_ONE_PROFESSIONAL, `/professional/free/${id}`, Object.assign({ id }, (meta || {})));
